import React, { Component } from 'react';
import styled, {keyframes} from 'styled-components';

const tour2Panel = keyframes `
  from, 50% { opacity: 0; transform: translate3d(0, 20px, 0) }
  to        { opacity: 1; transform: translate3d(0, 0, 0) }
`;


const PopoverContainer = styled.div`
  position: relative;
`;

const PopoverLink = styled.div`
    position: absolute;
    z-index: 3;
    right: 0;
    left: 0;
    margin: 0 auto;
    top: 130px;
    width: fit-content;
    width: -moz-fit-content;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    padding-bottom: 1rem;
    color: #008cff;
    &:hover:after {
        content: '';
        border-top: 1px solid #008cff;
        display: block;
        position: absolute;
        bottom: 18px;
        width: 100%;
    }
`;

const GrayBox = styled.div`
    width: 100%;
    background: #f0f3f7;
    height: 592px;
    position: relative;
`;

const PopoverPanelContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    z-index: 4;
    width: 24rem;
    height: fit-content;
    padding-top: 1rem;
`;

const PopoverPanel = styled.div`
    border: 1px solid #DEE2E6;
    border-radius: 8px;
    background: white;
    box-shadow: 0 8px 16px 0 rgba(50, 73, 93, 0.2);
    position: relative;

    h2.panel-title {
        color: #343A40;
        font-size: 1.125rem;
        font-weight: 700;
        line-height: 2rem;
        margin-bottom: .5rem;
        display: inline-block;
    }

    p {
        color: #343A40;
        font-family: -apple-system, BlinkMacSystemFont, "SF UI Text", San Francisco, Segoe UI, sans-serif;
        font-size: 1rem;
        line-height: 1.5rem;
        margin-bottom: 2rem;
    }

    a {
        color: #525252;
        display: block;
        width: fit-content;
        width: -moz-fit-content;
        border-bottom: 1px dotted #DEE2E6;
        cursor: pointer;
        margin-bottom: 4px;
        
        &:hover {
            border-bottom: 1px solid #0087ff;
            color: #0087ff;
        }
    }

    .panel {
        padding: 1.5rem 0 0 0;
        background: white;
        border-radius: 8px;
        margin: auto;
    }

    &:before,
    &:after {
        content: "";
        position: absolute;
        top: 1.5rem;
        left: -12px;
        height: 1.5rem;
        width: 1.5rem;
        background: inherit;
        transform: rotate(315deg);
        border-top: inherit;
        border-left: inherit;
        box-shadow: inherit;
        border-radius: 4px 0 0 0;
        z-index: 1;
    }
    &:before {
        box-shadow: 0 4px 8px 0 rgba(50, 50, 93, 0.1);
        z-index: -1;
    }
    &:after {
        z-index: 100;
        box-shadow: none;
    }

    .panel-text {
        padding: 0 1.5rem;
    }
    .btn {
        cursor: pointer;
        border: none;
        border-radius: 4px;
        padding: 0;
        
        &.dismiss {
            position: absolute;
            right: 1.5rem;
            top: 1.5rem;
            background: none;
            pointer: cursor;
            
            a {
              border: none;
            }
        }
    }

    footer.panel-buttons {
        background: #EFF3F7;
        padding: 16px 24px;
        border-top: 1px solid #DEE2E6;
        border-radius: 0 0 8px 8px;
        a {
          margin: 0;
          border: none;
          display: inline-block;
          width: calc(50% - 4px);
          &:nth-child(1) {
            margin-right: 4px;
          }
          &:nth-child(2) {
            margin-left: 4px;
          }
        }
        .btn {
            box-shadow: 0 1px 3px 0 rgba(50, 50, 93, 0.1);
            color: #343A40;
            font-size: .875rem;
            font-weight: 600;
            line-height: 1rem;
            margin: 0;
            padding: 6px 0;
            display: inline-block;
            width: 100%;
            
            &.btn-gray {
              background: linear-gradient(0deg, #F9FAFB, #FFFFFF);
              border: 1px solid #ADB5BD;
              padding: 7px 0;
              
              &:hover {
                  background: linear-gradient(180deg, #F9FAFB, #F4F6F8);
              }
              &:active {
                  background: linear-gradient(180deg, #f4f6f8, #f4f6f8);
                  box-shadow: 0 0 0 0 transparent, inset 0 1px 1px 0 rgba(99,115,129,.1), inset 0 1px 4px 0 rgba(99,115,129,.2);
              }
            }
            &.btn-blue {
                border: 2px solid #008cff;
                color: #008cff;
                background: transparent;
                &:hover {
                    background: linear-gradient(180deg, #008cff, #008cff);
                    color: white;
                    svg g {
                        stroke: white;
                    }
                }
                &:active {
                    background: linear-gradient(180deg, #0C6EBE, #0C6EBE);
                    box-shadow: 0 0 0 0 transparent, inset 0 1px 1px 0 rgba(99,115,129,.1), inset 0 1px 4px 0 rgba(99,115,129,.2);
                }
                svg, span {
                    vertical-align: top;
                    display: inline-block;
                }
                svg {
                    margin-right: 6px;
                }
            }
        }
    }

    .reader-only {
        display: none;
    }
    .dismiss:hover svg path {
        fill: #000000;
    }


    &#tourpoint2 {
        animation: ${tour2Panel} .5s linear;
        &:before,
        &:after {
            top: -12px;
            right: 180px;
            left: auto;
            border-bottom: none;
            border-right: inherit;
            border-left: none;
            border-top: inherit;
            border-radius: 0 0 4px 0;
            bottom: auto;
        }
    }

    .icon {
        width: 32px;
        height: 32px;
        background: #00B880;
        border-radius: 100%;
        color: white;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        display: inline-block;
        margin-right: 8px;
    }
`;


class Popover extends Component {
  constructor() {
    super();
    this.state = {
      tour1: true
    }
  }
  showTourTip1(e){
    e.preventDefault();
    this.setState({tour1: false})
  }
  render() {
    return (
        <PopoverContainer>
            <PopoverLink onMouseOver={() => this.setState({ tour1: true })}>Sally Jones</PopoverLink>
            <GrayBox onMouseOver={() => this.setState({ tour1: false })} onMouseOut={() => this.setState({ tour1: true })} />
            {this.state.tour1 && 
                <PopoverPanelContainer>
                    <PopoverPanel id="tourpoint2" onMouseOver={() => this.setState({ tour1: true })} >
                      <div className="panel">
                          <div className="panel-text">
                            <div className="icon"><span>SJ</span></div>
                            <h2 className="panel-title">Sally Jones</h2>
                            <nav className="panel-nav">
                                <button className="btn btn-link dismiss">
                                    <a onClick={this.showTourTip1.bind(this)} href='#' aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10px" height="10px"><path fill="#ADB5BD" fillRule="nonzero" d="M3.586 5L.293 8.293c-.39.39-.39 1.024 0 1.414.39.39 1.024.39 1.414 0L5 6.414l3.293 3.293c.39.39 1.024.39 1.414 0 .39-.39.39-1.024 0-1.414L6.414 5l3.293-3.293c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0L5 3.586 1.707.293c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414L3.586 5z"/></svg></a>
                                    <span className="reader-only">close modal</span>
                                </button>
                            </nav>
                            <div className="modal-body panel-content">
                                <p>
                                    <a>50 Main St, Sommerville MA 02144</a>
                                    <a>(617) 555-1234</a>
                                    <a>sjones@gmail.com</a>
                                </p>
                            </div>
                          </div>
                          <footer className="panel-buttons">
                              <a><button className="btn btn-gray">View Profile</button></a>
                              <a><button className="btn btn-blue"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><g fill="none" fill-rule="evenodd" stroke="#0087FF" stroke-linecap="round" stroke-width="2"><path d="M8 2v12M2 8h12"/></g></svg>Follow</button></a>
                          </footer>
                      </div>
                  </PopoverPanel>
              </PopoverPanelContainer>
          }
        </PopoverContainer>
    );
  }
}

export default Popover;



// WEBPACK FOOTER //
// src/assets/ProgressComponents/Popover/Popover.js